<template>
    <div class="contact-promotions">
        <template v-if="!hasPromotions">
            <div class="contact-view__no-data">Contact has no promotions</div>
        </template>
        <template v-else>
            <div class="contact-promotions__header">
                <label class="contact-promotions__title">Name</label>
                <label class="contact-promotions__title">Coupon</label>
                <label class="contact-promotions__title">Allocated</label>
            </div>
            <contact-promotion
                v-for="promotionCoupon in list"
                :key="promotionCoupon.id"
                :promotion-coupon="promotionCoupon"
                data-test="contact-promotion"
            ></contact-promotion>
            <div v-if="fetchParams.cursor"
                class="vx-mt-8 vx-flex vx-justify-between vx-items-center vx-w-full vx-gap-10">
                <vx-button @click="loadData()"
                    data-test="load-more-btn"
                    color="muted-dark"
                    class="vx-grow sm:vx-grow-0">
                    Load More
                    <font-awesome-icon :icon="faSpinner" :spin="loading"></font-awesome-icon>
                </vx-button>
            </div>
        </template>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import ContactPromotion from './ContactPromotion.vue';
import contactsClient from '../../../services/contactsClient';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton } from '@voxie/frontend-components';
import { useCursorPagination } from '../../../composables/useCursorPagination';

const props = defineProps({
    contact: {
        type: Object,
        required: true,
    },
});

const { list, loading, fetchParams, fetchRecords } = useCursorPagination();

const defaultFilters = () => {
    return {
        per_page: 100,
        cursor: null,
        sort_dir: 'desc',
    }
};

const hasPromotions = computed(() => list.value.length > 0);

const loadData = () => {
    fetchRecords(contactsClient.listPromotionCoupons(Spark.state.currentTeam.id, props.contact.id, fetchParams.value));
};

onMounted(() => {
    fetchParams.value = defaultFilters();

    loadData();
});

</script>

<style lang="scss">
.contact-promotions {
    display: flex;
    flex-direction: column;
}

.contact-promotions__header {
    display: grid;
    grid-template-columns: 50% 25% 25%;
    font-family: var(--font-open-sans);
    font-weight: var(--weight-regular);
    font-size: 0.8125rem; // 13px;;
    line-height: 1.25rem;
    color: var(--color-grey-600);
    margin-bottom: 8px;
}

.contact-promotions__title {
    margin: 0;
    padding: 0 16px;
}
</style>
